import { Scale } from 'lucide-react'

import type { ResEoirCaseDetailQuery } from '@/lib/queries/business/v1/case/eoir/types'
import { cn } from '@/lib/utils'

import { Description } from '../description/description'

interface CourtInformationProps {
  className?: string
  caseDetail?: ResEoirCaseDetailQuery
}

export const ApplicantCaseEoirDetailCourtInformation: React.FC<CourtInformationProps> = ({ className, caseDetail }) => {
  const court = caseDetail?.courtContact

  return (
    <div className={cn('p-5', 'rounded-[10px] border border-slate-200', className)}>
      <div className={cn('mb-[25px] flex items-center gap-2', 'text-[14px] font-[600] leading-[22px]')}>
        <Scale size={24} />
        Court Information
      </div>

      {!court ? (
        <div className={cn('px-5 py-2.5', 'rounded-[5px] bg-[#f8f8f8]', 'text-[12px] font-[500] leading-[18px]')}>
          No court information.
        </div>
      ) : (
        <div className={cn('flex flex-col gap-3')}>
          <Description title="Court Address" description={court?.address ?? '-'} />
          <Description title="Phone Number" description={court?.phoneNumber ?? '-'} />
        </div>
      )}
    </div>
  )
}
